export default "__VITE_ASSET__BWRXW1Pm__"